import React from "react";
import SearchInfo from "../SearchInfo";

const leftDefaultWidth = 680;
const rightDefaultWidth = 400;

export const left = {
  pages: {
    Layers: { content: SearchInfo, defaultWidth: leftDefaultWidth },
  },
  defaultWidth: leftDefaultWidth,
};
